<template>
  <div class="edit-base-shelf-item">
    <div class="edit-shelfname-label">
      快速切换报刊
      <i class="vip">VIP</i>
      <el-tooltip class="item" effect="dark" :content="title" placement="top" popper-class="read-classify-tip">
        <img src="@imgs/switch-book-tip.png" alt="" class="question" />
      </el-tooltip>
    </div>
    <el-select class="personal-item-select" size="mini" v-model="switchValue" @change="changeSwitchType">
      <el-option v-for="item in switchBooksOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <div class="relevanceTip" v-show="switchValue == 1">
      <el-input type="textarea" v-model="relevanceText" :disabled="nameDisabled" maxlength="6" placeholder="请填写名称，如：查看往期、历史刊物...." class="edit-shelfname-input" resize="none" />
    </div>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
  </div>
</template>

<script>
import TipDialog from '@components/common/TipDialog.vue'
import api from '@api/BookShelf'
import compareVipRight from '@components/common/compareVipRight.js'

export default {
  name: 'shelfSwitchBooks',
  props: {
    type: Object
  },
  data() {
    return {
      switchValue: 0,
      switchBooksOptions: [
        {
          value: 0,
          label: '关闭'
        },
        {
          value: 1,
          label: '开启'
        }
      ],
      title: '将设置了刊期的电子书刊添加到专辑已选列表，当列表中的刊期类型一致，开启此设置，即可实现阅读电子书刊时快速切换查看往期内容的效果。'
    }
  },
  mixins: [compareVipRight],
  computed: {
    relevanceText: {
      get: function() {
        return this.$store.state.config.bookShelfObj.relevanceText
      },
      set: function(newValue) {
        this.$store.commit('config/UPDATE_BOOKSHELFRELEVANCETEXT', newValue)
      }
    },
    albumId() {
      return window.sessionStorage.getItem('albumId')
    },
    nameDisabled() {
      return !this.compare({ type: 'boole', key: 'viewLastContent' }) && !!this.switchValue
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    }
  },
  components: {
    TipDialog
  },
  methods: {
    async changeSwitchType() {
      if (this.switchValue) {
        // 校验是否是会员和是否能使用快速切换报刊功能
        if (!(await this.compareRight({ type: 'boole', key: 'viewLastContent' }))) {
          this.$refs.memberDialog.visible = true
          this.switchValue = 0
        }
      }
    },
    canSwitchBooks() {
      const params = {
        id: this.albumId
      }
      api.quickSwitchBooks(params).then((res) => {
        const data = res.data.data
        if (!data) {
          this.switchValue = 0
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-shelfname-label {
  display: flex;
  align-items: center;
  .question {
    margin-left: 5px;
    height: 16px;
  }
  .vip {
    width: 30px;
    line-height: 20px;
    background: #df5813;
    text-align: center;
    color: #fff;
    font-size: 10px;
    margin-left: 5px;
    border-radius: 2px;
    font-style: normal;
    font-weight: bold;
  }
}
.relevanceTip {
  margin-top: 10px;
  /deep/ .el-textarea {
    height: 54px !important;
    .el-textarea__inner {
      height: 54px;
    }
  }
}
</style>
